import React from 'react'
import { CardStackIcon } from './card-stack-icon'

const paymentDropdownAllOptions = [
  {
    primaryText: 'Cards',
    value: 'cards',
    decoration: <CardStackIcon width="23px" fill="#003087" />,
  },
  {
    primaryText: 'PayPal',
    value: 'paypal',
    decoration: (
      <img
        src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-mark-color.svg"
        style={{ width: '24px' }}
      />
    ),
  },
  {
    primaryText: 'Venmo',
    value: 'venmo',
    decoration: (
      <img
        src="https://www.paypalobjects.com/paypal-ui/logos/svg/venmo-mark-color.svg"
        style={{ width: '24px' }}
      />
    ),
  },
]

const paymentDropdownOptions = [
  {
    primaryText: 'Cards',
    value: 'cards',
    decoration: <CardStackIcon width="23px" fill="#003087" />,
  },
  {
    primaryText: 'PayPal',
    value: 'paypal',
    decoration: (
      <img
        src="https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-mark-color.svg"
        style={{ width: '24px' }}
      />
    ),
  },
]

const paymentList = ['Cards', 'PayPal', 'Venmo']
const paymentListRegex = new RegExp(paymentList.join('|'), 'gi')
const _paymentListRegex = new RegExp(paymentList.join(' '), 'gi')

export {
  paymentDropdownOptions,
  paymentDropdownAllOptions,
  paymentList,
  paymentListRegex,
  _paymentListRegex,
}
